import { FC } from 'react';

import { Icon, Image, NavigateButton } from '@/components/ui';
import { cn } from '@/utils';
import { selectMainImage } from '@/utils/select-main-image';

export interface TextImageContainerProps {
  image: string;
  title: string;
  description: string;
  reverse?: boolean;
  button?: {
    text: string;
    href: string;
    startIcon?: string;
    endIcon?: string;
  };
  /** Optional class for the outer wrapper (e.g. studio section). */
  className?: string;
  /** Optional background style for the section (e.g. studio section). */
  background?: string;
  titleColor?: string;
  descriptionColor?: string;
}

const ImageTextContainer: FC<TextImageContainerProps> = ({
  image,
  title,
  description,
  reverse = false,
  button,
  className,
  background,
  titleColor,
  descriptionColor,
}) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-4 py-10 @md:flex-row @md:gap-8 @md:py-8',
        reverse ? '@md:flex-row-reverse' : '@md:flex-row',
        className,
      )}
      style={background ? { backgroundColor: background } : undefined}
    >
      <div className="w-full flex-1 @md:w-[228px] @lg:w-[628px]">
        <Image
          src={selectMainImage([image])}
          alt={title}
          className="h-auto w-full max-w-full rounded-2xl"
          width="fill"
        />
      </div>
      <div className="w-full flex-1">
        <h2
          className="mb-4 text-xl font-bold @md:text-3xl"
          style={titleColor ? { color: titleColor } : undefined}
        >
          {title}
        </h2>
        <p
          className="text-sm text-gray-700 @md:text-lg"
          style={descriptionColor ? { color: descriptionColor } : undefined}
        >
          {description}
        </p>
        {button?.text ? (
          <div className="mt-6 flex justify-start">
            <NavigateButton
              href={button.href || '/'}
              color="primary"
              className="font-medium"
              startContent={button.startIcon ? <Icon icon={button.startIcon} /> : undefined}
              endContent={button.endIcon ? <Icon icon={button.endIcon} /> : undefined}
            >
              {button.text}
            </NavigateButton>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ImageTextContainer;
